<template>
    <div class="error-page">
        <v-img src="images/security.svg"/>
        <div class="error-message">
            <h1>{{ $t("error.forbidden") }}</h1>
            <p>{{ $t("error.forbidden_message") }}</p>
            <v-btn class="btn-default" elevation="0" @click="$router.push({
            name:'Bundles'
            })">
                {{ $t("error.back") }}
            </v-btn>
        </div>
    </div>
</template>

<script>
export default {
    name: "Error403",
};
</script>
